import { useGetCurrentUser } from 'gcs-common/clients/api/entities/current-user/current-user-api';
import LoginForm from 'gcs-common/components/LoginForm/LoginForm';
import { CHAT_ROUTES } from 'gcs-common/constants/routes';
import { Navigate } from 'react-router';

const SubmitUserCode = () => {
  const { isSuccess } = useGetCurrentUser();

  if (isSuccess) {
    return <Navigate to={CHAT_ROUTES.CHAT} replace />;
  }

  return <LoginForm />;
};

export default SubmitUserCode;
